// Mock data for Boulter Property Group clone
// NOTE: All data here is MOCKED for the frontend-only build.

export const BRAND = {
  name: "Boulter Group",
  logoLight:
    "https://cdn.prod.website-files.com/67e7c74aad9a5c8ee098dcb9/67e7cbdce10fc56e50e7d522_logo-boulter.svg",
  phone: "0800 2922526",
  phoneHref: "tel:08002922526",
  email: "info@boulterpropertygroup.com",
  address: "Road Farm, Thaxted Road, Little Sampford, Saffron Walden, CB10 2RZ, England",
  contactName: "our team",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Who We Are", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  heroHomes: "https://images.unsplash.com/photo-1621983209348-7b5a63f23866?auto=format&fit=crop&w=1600&q=80",
  modernHome: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1400&q=80",
  coupleKeys: "https://images.unsplash.com/photo-1580709430621-697349bd4bb9?auto=format&fit=crop&w=1400&q=80",
  happyCouple: "https://images.unsplash.com/photo-1655759738595-418970010986?auto=format&fit=crop&w=1400&q=80",
  community: "https://images.unsplash.com/photo-1602941525421-8f8b81d3edbb?auto=format&fit=crop&w=1400&q=80",
  constructionSite: "https://images.unsplash.com/photo-1699021565893-e8aaa1f72aba?auto=format&fit=crop&w=1400&q=80",
  concreteMixer: "https://images.pexels.com/photos/6082416/pexels-photo-6082416.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  renovation: "https://images.unsplash.com/photo-1634586648651-f1fb9ec10d90?auto=format&fit=crop&w=1400&q=80",
  scaffolding: "https://images.pexels.com/photos/19616327/pexels-photo-19616327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  landAerial: "https://images.unsplash.com/photo-1726592058857-9caed196773d?auto=format&fit=crop&w=1400&q=80",
  blueprint: "https://images.unsplash.com/photo-1608303588026-884930af2559?auto=format&fit=crop&w=1400&q=80",
  electrician: "https://images.pexels.com/photos/34054464/pexels-photo-34054464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  plumber: "https://images.unsplash.com/photo-1676210134050-6f12c6898395?auto=format&fit=crop&w=1400&q=80",
  apartment: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1400&q=80",
  luxuryDusk: "https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?auto=format&fit=crop&w=1600&q=80",
  smallProject: "https://images.unsplash.com/photo-1672626881472-b96d3eb5445e?auto=format&fit=crop&w=1400&q=80",
  ukField: "https://customer-assets.emergentagent.com/job_boulter-revamped/artifacts/f3u6o5ax_new-photo-of-land-800x533-2.jpg",
};

export const SERVICES = [
  {
    id: "new-homes",
    name: "New Homes",
    tagline: "Making home ownership a reality",
    icon: "Home",
    image: IMAGES.community,
    short:
      "Affordable, sustainable, good-quality homes designed around the next generation of homeowners.",
    body: [
      "We want to make home ownership achievable for young people, removing financial barriers with affordable, sustainable, good-quality homes designed around their needs.",
      "We wish to work with trusted investors to support a housing solution that helps young people build commitment, build communities, and get on the housing ladder.",
      "We build and maintain welcoming, eco-conscious communities, delivering energy-efficient homes that lower carbon and suit modern living, and we are on track to be the trusted housebuilder for a generation to come.",
    ],
    sector: "Residential",
  },
  {
    id: "land-investment",
    name: "Land & Investment",
    tagline: "Unlocking the potential of land",
    icon: "Map",
    image: IMAGES.ukField,
    short:
      "Identifying and developing high-potential land and property opportunities for landowners and investors.",
    body: [
      "Boulter Group identifies and develops high-potential land and property opportunities, offering tailored solutions for landowners and investors alike.",
      "With decades of experience, we combine insight, innovation and sustainability to deliver quality developments that create lasting value for both partners and communities. We're actively seeking strategic land and property opportunities to unlock value and drive meaningful growth.",
    ],
    sector: "Development",
  },
  {
    id: "lettings-management",
    name: "Lettings & Management",
    tagline: "Straightforward ownership, reliable returns",
    icon: "KeyRound",
    image: IMAGES.apartment,
    short:
      "End-to-end management for landlords and high-quality, well-maintained homes for tenants.",
    body: [
      "We provide end-to-end services including tenant sourcing, lease management, rent collection, deposit protection and ongoing maintenance ensuring hassle free ownership and optimal returns for landlords.",
      "For tenants, we offer high-quality, well maintained homes designed for modern living, backed by responsive service for a smooth, stress-free experience. With a transparent, client-focused approach, we build trust and long-term relationships.",
    ],
    sector: "Residential",
  },
  {
    id: "services-maintenance",
    name: "Maintenance",
    tagline: "Keeping property in prime condition",
    icon: "Wrench",
    image: IMAGES.electrician,
    short:
      "Comprehensive maintenance for both residential and commercial properties, from quick fixes to full refurbishments.",
    body: [
      "We provide comprehensive maintenance across both residential and commercial properties — from a single home or portfolio to full block services and large commercial premises, handling everything from routine upkeep to emergency repairs.",
      "Our skilled in-house team covers a full range of trades and disciplines, including:",
    ],
    bullets: [
      "Commercial fit-outs",
      "Electrical",
      "Audio Visual & security",
      "Solar PV",
      "Dry lining",
      "Plumbing",
      "Carpentry",
      "External landscaping works",
    ],
    sector: "Residential & Commercial",
  },
  {
    id: "consultancy",
    name: "Consultancy",
    tagline: "End-to-end development expertise",
    icon: "ClipboardList",
    image: IMAGES.blueprint,
    short:
      "Project, development and cost management across residential, commercial and industrial projects.",
    body: [
      "Our expert team delivers end-to-end property development consultancy, including project, development, and cost management services. From land acquisition and due diligence to planning, construction and aftercare, we manage every stage of the development process.",
      "Our experience spans residential, commercial and industrial projects, as well as sustainable initiatives such as solar installations and EV charging infrastructure ensuring efficient, innovative, and high-quality outcomes.",
    ],
    sector: "Development",
  },
  {
    id: "construction",
    name: "Construction",
    tagline: "Quality construction, start to finish",
    icon: "HardHat",
    image: IMAGES.constructionSite,
    short:
      "Delivering quality projects from £35,000 to £8 million across new builds, renovations and repairs.",
    body: [
      "We deliver quality construction projects from £35,000 to £8 million, across new builds, renovations and repairs in UK residential and commercial properties.",
      "Our focus is on sustainable, well-built work, with eco-conscious choices at the core and high health and safety standards on every project.",
    ],
    sector: "Development",
  },
];

export const SECTORS = [
  {
    id: "residential",
    title: "Residential",
    blurb:
      "From new homes and lettings to ongoing maintenance — everything a homeowner or landlord needs under one trusted roof.",
    image: IMAGES.coupleKeys,
    points: ["New Homes", "Lettings & Management", "Maintenance"],
    to: "/services#new-homes",
  },
  {
    id: "development",
    title: "Development",
    blurb:
      "Land, investment, consultancy and construction — helping turn opportunities into places that last.",
    image: IMAGES.smallProject,
    points: ["Land & Investment", "Consultancy", "Construction"],
    to: "/services#land-investment",
  },
];

export const STATS = [
  { value: "£8M", label: "Largest project value" },
  { value: "6", label: "Specialist sectors" },
  { value: "100%", label: "Eco-conscious focus" },
  { value: "UK", label: "Nationwide coverage" },
];

export const WHY = [
  {
    icon: "ShieldCheck",
    title: "Highest Standards",
    text: "Every project is delivered to a high standard, with health & safety taken seriously throughout.",
  },
  {
    icon: "Leaf",
    title: "Eco-Conscious",
    text: "Sustainable materials and energy-efficient technology are part of everything we build.",
  },
  {
    icon: "Users",
    title: "You Ask, We Listen",
    text: "A client-focused, transparent approach that guides you to the best, most cost-effective outcome.",
  },
  {
    icon: "Award",
    title: "Our Name, Our Reputation",
    text: "A family-run team trusted to deliver lasting value for partners and communities.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Sarah & James T.",
    role: "First-time buyers",
    quote:
      "Boulter made owning our first home genuinely achievable. The team guided us through every step and the quality of the build is outstanding.",
  },
  {
    name: "Marcus Bell",
    role: "Landowner & Partner",
    quote:
      "They unlocked real value from a site I'd struggled to move for years. Professional, transparent and full of energy from day one.",
  },
  {
    name: "Priya Nandra",
    role: "Portfolio Landlord",
    quote:
      "Their lettings and maintenance team keeps my properties in prime condition. Hassle-free ownership, exactly as promised.",
  },
];

export const SERVICE_OPTIONS = [
  "Land and Investment",
  "New Homes",
  "Partner Opportunities",
  "Consultancy",
  "Maintenance",
  "Lettings and Management",
];
